import { render, staticRenderFns } from "./change-theme.vue?vue&type=template&id=07820af3&"
import script from "./change-theme.vue?vue&type=script&lang=ts&"
export * from "./change-theme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports